import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { correctAllExercises, terminateSection } from '../../../../actions/status';
import { hideModal } from '../../../../actions/modal';
import { RESULTS } from '../../../../constants/routes';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';
import { currentSectionIsLast } from '../../../../lib/status';

export const Message = styled.span``;

export const TimeOutModalBody = ({ correctAllExercises, exercises, onClose, status, terminateSection }) => {
    const history = useNavigate();

    const { answers, id: statusId, finished, sections } = status;

    const isLastSection = !!sections && currentSectionIsLast(sections);

    const messageText =
        `Hai finito il tempo a disposizione per terminare la ${!!sections ? 'sezione' : 'prova'}.` +
        `${!!sections && isLastSection ? '\nNon ci sono altre sezioni da svolgere.' : ''}`;
    const primaryButtonText = !!sections && !isLastSection ? 'Vai alla prossima sezione' : 'Vai ai risultati';

    const onConfirm = async () => {
        if (!!sections && !finished) {
            await terminateSection(statusId, true);
            if (!isLastSection) {
                onClose();
                return;
            }
        }

        correctAllExercises(exercises, answers);
        onClose();
        setTimeout(history, 0, RESULTS, { replace: true });
    };

    return (
        <Modal title="Tempo scaduto" onClose={onConfirm} closeOnClickOutside={false} drawCloseButton={false}>
            <ModalBodyContainer>
                <Content>
                    <Message className="body-3">{messageText}</Message>
                </Content>
                <Buttons primaryButtonClick={onConfirm} primaryButtonText={primaryButtonText} showTertiaryButton={false} />
            </ModalBodyContainer>
        </Modal>
    );
};

TimeOutModalBody.propTypes = {
    correctAllExercises: PropTypes.func,
    exercises: PropTypes.array,
    onClose: PropTypes.func.isRequired,
    status: PropTypes.object,
    terminateSection: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        exercises: state.homework.exercises,
        status: state.status,
    };
};

const actionsCreator = {
    onClose: hideModal,
    correctAllExercises,
    terminateSection,
};

export default connect(mapStateToProps, actionsCreator)(TimeOutModalBody);
